/*
 * BoldStuff predictive search — product suggestions dropdown.
 *
 * Attaches to the header + mobile search inputs. As the user types (2+ chars,
 * debounced) it queries Shopify's predictive search API and shows a dropdown
 * below the input: product IMAGE on the left, product NAME on the right.
 *
 * Self-contained: injects its own CSS, so it survives header template edits.
 */
(function () {
  var MIN_CHARS = 1;     // suggest as soon as there is 1+ character
  var DEBOUNCE = 150;    // ms to wait after typing pauses
  var LIMIT = 8;         // max suggestions

  var SROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ENDPOINT = SROOT.replace(/\/$/, '') + '/search/suggest.json';

  function injectStyles() {
    if (document.getElementById('bs-predictive-search-styles')) return;
    var css =
      '.bs-search-has-suggest{position:relative;}' +
      '.mobile-search-form{position:relative;}' +
      '.bs-search-suggest{position:absolute;top:calc(100% + 8px);right:0;width:340px;max-width:90vw;' +
        'background:#000;border:1px solid rgba(255,255,255,.12);border-radius:10px;' +
        'box-shadow:0 12px 30px rgba(0,0,0,.45);overflow:hidden;z-index:1002;}' +
      '.bs-search-suggest[hidden]{display:none;}' +
      '.bs-search-suggest__list{max-height:60vh;overflow-y:auto;scrollbar-width:none;-ms-overflow-style:none;}' +
      '.bs-search-suggest__list::-webkit-scrollbar{display:none;width:0;height:0;}' +
      '.bs-suggest-item{display:flex;align-items:center;gap:12px;padding:10px 14px;text-decoration:none;' +
        'border-bottom:1px solid rgba(255,255,255,.08);transition:background .15s ease;}' +
      '.bs-suggest-item:last-child{border-bottom:none;}' +
      '.bs-suggest-item:hover,.bs-suggest-item.is-active{background:rgba(255,255,255,.07);}' +
      '.bs-suggest-item__img{flex:0 0 48px;width:48px;height:48px;border-radius:6px;background:#1a1a19;' +
        'overflow:hidden;display:flex;align-items:center;justify-content:center;}' +
      '.bs-suggest-item__img img{width:100%;height:100%;object-fit:cover;}' +
      '.bs-suggest-item__name{flex:1;min-width:0;font-size:14px;line-height:1.35;color:#fff;font-weight:500;}' +
      '.bs-suggest-empty{padding:16px;text-align:center;color:#aaa;font-size:13px;}' +
      '@media (max-width:991px){.bs-search-suggest{left:0;right:0;width:100%;max-width:none;}}';
    var style = document.createElement('style');
    style.id = 'bs-predictive-search-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function imgUrl(p) {
    var u = '';
    if (p.featured_image && p.featured_image.url) u = p.featured_image.url;
    else if (typeof p.image === 'string') u = p.image;
    else if (p.image && p.image.url) u = p.image.url;
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function attach(input) {
    if (!input || input.__bsSuggest) return;
    input.__bsSuggest = true;

    var form = input.closest('form');
    if (!form) return;
    form.classList.add('bs-search-has-suggest');

    var box = document.createElement('div');
    box.className = 'bs-search-suggest';
    box.setAttribute('hidden', '');
    var list = document.createElement('div');
    list.className = 'bs-search-suggest__list';
    box.appendChild(list);
    form.appendChild(box);

    var timer = null, lastQ = '', controller = null;

    function hide() { box.setAttribute('hidden', ''); }
    function show() { box.removeAttribute('hidden'); }

    function render(products) {
      list.innerHTML = '';
      if (!products || !products.length) {
        var empty = document.createElement('div');
        empty.className = 'bs-suggest-empty';
        empty.textContent = 'No matching products';
        list.appendChild(empty);
        show();
        return;
      }
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'bs-suggest-item';
        a.href = p.url;

        var imgWrap = document.createElement('span');
        imgWrap.className = 'bs-suggest-item__img';
        var src = imgUrl(p);
        if (src) {
          var img = document.createElement('img');
          img.src = src;
          img.alt = '';
          img.loading = 'lazy';
          imgWrap.appendChild(img);
        }

        var name = document.createElement('span');
        name.className = 'bs-suggest-item__name';
        name.textContent = p.title || '';

        a.appendChild(imgWrap);
        a.appendChild(name);
        list.appendChild(a);
      });
      show();
    }

    function doFetch(q) {
      if (controller && controller.abort) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = ENDPOINT + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=' + LIMIT +
        '&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(products);
        })
        .catch(function () { /* aborted / network error — ignore */ });
    }

    function clearSuggest() {
      clearTimeout(timer);
      if (controller && controller.abort) controller.abort();
      lastQ = '';
      list.innerHTML = '';
      hide();
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { clearSuggest(); return; }  // empty/cleared → no suggestions
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (q !== lastQ) { lastQ = q; doFetch(q); }
      }, DEBOUNCE);
    });

    // Native search "x" clear fires a 'search' event with an empty value.
    input.addEventListener('search', function () {
      if (!input.value.trim()) clearSuggest();
    });

    // The theme's custom clear button doesn't fire 'input' — hook it directly.
    var clearBtn = form.querySelector('.header-search-clear, .mobile-search-clear');
    if (clearBtn) clearBtn.addEventListener('click', clearSuggest);

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && list.children.length) show();
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) hide();
    });
  }

  function init() {
    injectStyles();
    var inputs = document.querySelectorAll('.header-search-input, .mobile-search-input');
    Array.prototype.forEach.call(inputs, attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
